import {
    call,
    put,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import Store from "../../Store/Store";
import Time from "../../Time/Time";

export default function* chargesSaveList(action: ActionInterface): any {
  try {
		let request = "charges?";

		typeof action.payload?.sortBy !== "undefined" ?
            request += `&sort_by=${action.payload?.sortBy}` : "sort_by=firstDate";

    typeof action.payload?.firstItem !== "undefined" ?
            request += `&first_item=${action.payload?.firstItem}` : request;

    typeof action.payload?.lastItem !== "undefined" ?
            request += `&last_item=${action.payload?.lastItem}` : request;

    typeof action.payload?.paid !== "undefined" ?
            request += `&paid=${action.payload?.paid}` : request;

    typeof action.payload?.chargeClassId !== "undefined" ?
            request += `&charge_class_id=${action.payload?.chargeClassId}` : request;

    typeof action.payload?.propertyId !== "undefined" ?
            request += `&property_id=${action.payload?.propertyId}` : request;

    typeof action.payload?.unitId !== "undefined" ?
            request += `&unit_id=${action.payload?.unitId}` : request;

    typeof action.payload?.contractId !== "undefined" ?
            request += `&contract_id=${action.payload?.contractId}` : request;

    typeof action.payload?.companyId !== "undefined" ?
            request += `&company_id=${action.payload?.companyId}` : request;

    typeof action.payload?.contactId !== "undefined" ?
            request += `&contact_id=${action.payload?.contactId}` : request;

    typeof action.payload?.ownerId !== "undefined" ?
            request += `&owner_id=${action.payload?.ownerId}` : request;

    typeof action.payload?.paymentId !== "undefined" ?
						request += `&payment_id=${action.payload?.paymentId}` : request;

		typeof action.payload?.eventId !== "undefined" ?
						request += `&event_id=${action.payload?.eventId}` : request;

		typeof action.payload?.chargesForContracts !== "undefined" ?
            request += `&charges_for_contracts=${action.payload?.chargesForContracts}` : request;

    typeof action.payload?.unpaidAmount !== "undefined" ?
            request += `&unpaid_amount=${action.payload?.unpaidAmount}` : request;

		typeof action.payload?.filterValue !== "undefined" ?
						request += `&q=${action.payload?.filterValue}` : request;

		typeof action.payload?.removed !== "undefined" ?
						request += `&removed=${action.payload?.removed}` : request;

		typeof action.payload?.isAfterStartDate !== "undefined" ?
						request += `&is_after_start_date=${action.payload?.isAfterStartDate}` : request;

		typeof action.payload?.invoiceDate !== "undefined" ?
						request += `&invoice_date=${Time.formatOrNull(action.payload?.invoiceDate)}` : request;

		typeof action.payload?.invoiceNumber !== "undefined" ?
						request += `&invoice_number=${action.payload?.invoiceNumber}` : request;
		typeof action.payload?.invoiceNumber !== "undefined" ?
						request += `&agency_only=${action.payload?.agencyOnly}` : request;

		typeof action.payload?.excludeChargeTypeId !== "undefined" ?
						request += `&exclude_charge_type_ids=${action.payload?.excludeChargeTypeId}` : request;

		typeof action.payload?.excludeChargeTypeIds !== "undefined" ?
						request += "&exclude_charge_type_ids=" + action.payload?.excludeChargeTypeIds.join(",") : request;
						
		typeof action.payload?.hideZeroPayout !== "undefined" ?
						request += `&hide_zero_payout=${action.payload?.hideZeroPayout}` : request;
						
		typeof action.payload?.isOverdue !== "undefined" ?
                                                request += `&is_overdue=${action.payload?.isOverdue}` : request;
            
		typeof action.payload?.isSnoozed !== "undefined" ?
						request += `&is_snoozed=${action.payload?.isSnoozed}` : request;
								
		typeof action.payload?.toSettleChargeId !== "undefined" ?
                                                request += `&to_settle_charge_id=${action.payload?.toSettleChargeId}` : request;

                typeof action.payload?.sortByPeriod !== "undefined" ?
                                                request += `&sort_by_period=${action.payload?.sortByPeriod}` : request;

    // if request was done should search for info in store
    if (!action.payload?.fetchAllCharges && !Store.getConfigurator().getState().charges?.requestsOutdated && Object.keys(Store.getConfigurator().getState().charges?.requests || {}).includes(request)) {
        return action.onSuccess.call(this,
        Store.getConfigurator().getState().charges.requests[request]);
    }
		const res = yield call(Http.get, request);

    const charges = res.data.rows.map(charge => {
      return ChargeFactory.create(charge);
		});

    const payload: any = {
      charges: charges,
      request: request,
      count: res.data.count
    };

    yield put({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST_SUCCESS,
      payload: {...payload}
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, {...payload});
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchChargesSaveList() {
  yield takeEvery(Constants.GLOBAL_CHARGES_SAVE_LIST, chargesSaveList);
}
